import { render, staticRenderFns } from "./CurrentOrdersTable.vue?vue&type=template&id=732fa8ba&scoped=true"
import script from "./CurrentOrdersTable.vue?vue&type=script&lang=js"
export * from "./CurrentOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732fa8ba",
  null
  
)

export default component.exports